import {BaseTerms} from "../../../../infrastructure/models/base-terms";

export class CurrentOddsModuleTerms extends BaseTerms {
  MATCH_RESULT_ODDS = "Match result odds";
}
